import React, {
  useCallback,
  useEffect,
  useMemo,
  useState,
} from "react";

import { useLocation, useNavigate } from "react-router-dom";

import { getLocalFranchiseStore, getUserData } from "../../../utils/localStorage";

import { FloatLabel } from "primereact/floatlabel";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import { Paginator } from "primereact/paginator";

import { FixedSizeList as List } from "react-window";

import SuccessModal from "../../SuccessModal";
import AdminMenu from "../../AdminMenu";

import {
  addPromotion,
  getBrandWhatsappConfig,
  getViewPromoTemplate,
  updatePromotion,
} from "../../../services/PromoTemplate/PromoTemplate";

import { getBrandCustomerV3, getBrandCustomerV4 } from "../../../services/BrandCustomer/BrandCustomer";

import { getBrandStore } from "../../../services/StoreUsers/PostStoreUsers";

const { innerHeight: height } = window;

const PromoTemplateFranchiseCreate = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const { item } = location.state || {};

  const { brandProfileData , userProfileRole} = getUserData();

    const userRole = userProfileRole;

  const brandId = brandProfileData.id;

  const isUpdating = Boolean(item?.id);

  const [visible, setVisible] = useState(false);

  const [modalVisible, setModalVisible] = useState(false);
  const [modalStatus, setModalStatus] = useState(false);
  const [modalText, setModalText] = useState("");

  const [isButtonPressed, setIsButtonPressed] = useState(false);

  const [promoTemplateList, setPromoTemplateList] = useState([]);

  const [brandWhatsappConfig, setBrandWhatsappConfig] = useState({});

  const [brandCustomers, setBrandCustomers] = useState([]);

  const [brandStoreList, setBrandStoreList] = useState([]);

  const [storeValue, setStoreValue] = useState();

  const [selectedRows, setSelectedRows] = useState([]);

  const [selectedOrderIds, setSelectedOrderIds] = useState([]);

  const [selectionError, setSelectionError] = useState("");

  const [promoTemplate, setPromoTemplate] = useState("");

  const [promoTemplateError, setPromoTemplateError] = useState("");

  const [page, setPage] = useState(0);

  const [totalRecords, setTotalRecords] = useState(0);

  const [selectedMobileNumbers, setSelectedMobileNumbers] = useState([]);

  const minimumDate = new Date();

  const maximumDate = new Date();
  maximumDate.setMonth(maximumDate.getMonth() + 3);

  const [startDate, setStartDate] = useState(new Date());

  useEffect(() => {
    if (item?.id) {
      setPromoTemplate(item?.brandPromoTemplate);
      setStartDate(new Date(item?.startOn));
    }
  }, [item]);

  const effectiveLimit = useMemo(() => {
    const whatsappLimit =
      brandWhatsappConfig?.whatsappPromoLimit || 0;

    const promoLeft =
      brandWhatsappConfig?.promoLeftCount ??
      whatsappLimit;

    return Math.min(whatsappLimit, promoLeft);
  }, [brandWhatsappConfig]);

  const fetchAllBrandStore = async () => {
    try {
      const response = await getBrandStore(brandId);

      if (!response.data.error) {
        const stores = response.data.map((item) => ({
          name: item.storeName,
          value: item.id,
        }));

        setBrandStoreList(stores);
      }
    } catch (error) {
      console.error(error);
    }
  };

   const fetchFranchiseStore = async () => {
      const franchiseStore = await getLocalFranchiseStore();
      if (franchiseStore.franchiseStore !== null) {
        const Res = franchiseStore.franchiseStore.filter(
          (item) => item.status === "ACTIVE",
        );

        const stores = Res.map((item) => ({
          name: item.storeName,
          value: item.id,
        }));

        setBrandStoreList(stores);
      } else {
        setBrandStoreList([]);
      }
    };
  
    useEffect(() => {
      if (userRole === "BY_FRANCHISE_ADMIN") {
        fetchFranchiseStore();
      } else {
        fetchAllBrandStore();
      }
    }, []);
 

   const fetchBrandCustomers = (pageNumber = 0, brandWhatsappConfig, storeId) => {
      if (!brandWhatsappConfig?.whatsappPromoLimit) return;
  
      const limit = brandWhatsappConfig.whatsappPromoLimit;
  
      const data = {
        sortOrder: "asc",
        sortBy: "id",
        limit,
        offset: pageNumber * limit,
        storeIdIn: [storeId]
      };
  
      getBrandCustomerV4(brandId, data)
        .then((response) => {
          if (!response.data.error) {
            const res = response.data || [];
  
            // 🔥 Replace old data
            setBrandCustomers(res);
            setTotalRecords(res.length);
            setPage(pageNumber);
          }
        })
        .catch((err) => console.error(err));
    };
  

  // const fetchBrandCustomers = async (
  //   pageNumber = 0,
  //   config = brandWhatsappConfig,
  //   storeId = storeValue
  // ) => {
  //   try {
  //     if (!config?.whatsappPromoLimit || !storeId) return;

  //     const limit = config.whatsappPromoLimit;

  //     const payload = {
  //       sortOrder: "asc",
  //       sortBy: "id",
  //       limit,
  //       offset: pageNumber * limit,
  //       storeIdIn: [storeId],
  //     };

  //     const response = await getBrandCustomerV3(
  //       brandId,
  //       payload
  //     );

  //     if (!response.data.error) {
  //       const rows = response.data?.rows || [];
  //       const count = response.data?.count || 0;

  //       setBrandCustomers(rows);
  //       setTotalRecords(count);
  //       setPage(pageNumber);
  //     }
  //   } catch (error) {
  //     console.error(error);
  //   }
  // };

  const fetchPromoTemplate = async (storeId) => {
    try {
      const [configRes, templateRes] = await Promise.all([
        getBrandWhatsappConfig(brandId),
        getViewPromoTemplate(brandId),
      ]);

      if (!configRes.data.error) {
        const config = configRes.data;

        setBrandWhatsappConfig(config);

        await fetchBrandCustomers(0, config, storeId);
      }

      if (!templateRes.data.error) {
        setPromoTemplateList(templateRes.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handlePageChange = ({ page }) => {
    fetchBrandCustomers(page);
  };

  const handleSelectionChange = (selected) => {
    if (selected.length > effectiveLimit) {
      setSelectionError(
        `You can select maximum ${effectiveLimit} customers`
      );

      const trimmed = selected.slice(0, effectiveLimit);

      setSelectedRows(trimmed);

      setSelectedOrderIds(
        trimmed.map((item) => item.id)
      );

      setSelectedMobileNumbers(
        trimmed.map((item) => item.mobile)
      );

      return;
    }

    setSelectionError("");

    setSelectedRows(selected);

    setSelectedOrderIds(
      selected.map((item) => item.id)
    );

    setSelectedMobileNumbers(
      selected.map((item) => item.mobile)
    );
  };

  const resetSelectedValue = () => {
    setSelectedRows([]);
    setSelectedOrderIds([]);
    setSelectedMobileNumbers([])
  };

  const handleSubmit = async () => {
    setPromoTemplateError("");

    if (!promoTemplate) {
      setPromoTemplateError("Promo Template Required");
      return;
    }

    if (selectedOrderIds.length === 0) {
      setSelectionError("Please select customers");
      return;
    }

    try {
      setIsButtonPressed(true);

      const payload = {
        brandTemplateId: promoTemplate.id,
        // customerIdList: selectedOrderIds,
        selectedMobileNumbers: selectedMobileNumbers,
        startOn: startDate.toISOString(),
      };

      const updatePayload = {
        brandPromotionId: item?.id,
        ...payload,
      };

      const response = isUpdating
        ? await updatePromotion(updatePayload, brandId)
        : await addPromotion(payload, brandId);

      if (!response.data.error) {
        const res = response.data;

        setModalVisible(true);

        setModalStatus(
          res.status ? "success" : "not Success"
        );

        setModalText(res.message);

        if (res.status) {
          setTimeout(() => {
            navigate("/PromoTemplateView");
          }, 1500);
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsButtonPressed(false);
    }
  };

  const Row = useCallback(
    ({ index, style }) => {
      const rowData = brandCustomers[index];

      if (!rowData) return null;

      const isSelected = selectedOrderIds.includes(
        rowData.id
      );

      return (
        <div
          style={{
            ...style,
            display: "flex",
            alignItems: "center",
            padding: "10px",
            borderBottom: "1px solid #ddd",
            background: isSelected
              ? "#e3f2fd"
              : "#fff",
          }}
        >
          <div style={{ width: "60px" }}>
            <input
              type="checkbox"
              checked={isSelected}
              onChange={(e) => {
                let updatedRows = [...selectedRows];

                if (e.target.checked) {
                  updatedRows.push(rowData);
                } else {
                  updatedRows = updatedRows.filter(
                    (item) => item.id !== rowData.id
                  );
                }

                handleSelectionChange(updatedRows);
              }}
            />
          </div>

          <div style={{ flex: 1 }}>
            {[rowData?.firstName, rowData?.lastName]
              .filter(Boolean)
              .join(" ")}
          </div>

          <div style={{ flex: 1 }}>
            {rowData?.mobile}
          </div>
        </div>
      );
    },
    [brandCustomers, selectedOrderIds, selectedRows]
  );

  return (
    <div
      className="flex-1"
      style={{ backgroundColor: "#FAF9F6" }}
    >
      {/* Header */}

      <div
        className="h-3rem surface-0 sticky z-2 mb-3 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex">
            <div className="ml-3 flex justify-content-center align-items-center">
              <i
                className="pi pi-angle-left"
                onClick={() =>
                  navigate("/PromoTemplateView")
                }
                style={{
                  fontSize: "27px",
                  cursor: "pointer",
                  color: "#fff",
                }}
              />
            </div>

            <div className="flex-1 ml-5">
              <p className="text-2xl text-white font-bold uppercase">
                Promo Template{" "}
                {isUpdating ? "Edit" : "Create"}
              </p>
            </div>
          </div>

          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{
                fontSize: "27px",
                marginRight: 30,
                color: "#fff",
              }}
            />
          </div>
        </div>
      </div>

      {/* Store Dropdown */}

      <div className="my-2 mx-4 flex flex-1">
        <Dropdown
          value={storeValue}
          options={brandStoreList}
          optionLabel="name"
          onChange={(e) => {
            setStoreValue(e.target.value);
            fetchPromoTemplate(e.target.value);
          }}
          placeholder="Select a Store"
          style={{ width: "100%" }}
          disabled={selectedOrderIds.length > 0}
        />
      </div>

      {!storeValue && (
        <p
          className="font-bold block mb-2 ml-2"
          style={{ color: "red" }}
        >
          Please Select Store For Promotion
        </p>
      )}

      {storeValue && (
        <>
          {/* Info */}

          <p
            className="font-bold block mb-2 ml-4"
            style={{ color: "red" }}
          >
            You Can Send/Schedule Upto{" "}
            {
              brandWhatsappConfig?.whatsappPromoLimit
            }{" "}
            Customers and Your Promo Left Count is{" "}
            {
              brandWhatsappConfig?.promoLeftCount
            }
          </p>

          {/* Selected */}

          <div className="flex flex-row justify-content-between">
            <p className="font-bold block mb-2 ml-4">
              Customer Info Total - (
              {brandCustomers.length}) Selected -{" "}
              {selectedOrderIds.length}
            </p>

            {selectedOrderIds.length > 0 && (
              <div
                className="p-button mx-4 p-1 mb-2 cursor-pointer"
                style={{
                  background: "red",
                  borderColor: "red",
                }}
                onClick={resetSelectedValue}
              >
                <p
                  className="text-md font-bold"
                  style={{ color: "white" }}
                >
                  Reset Data
                </p>
              </div>
            )}
          </div>

          {/* Virtual Table */}

          <div
            style={{
              margin: "0 16px",
              border: "1px solid #ddd",
              borderRadius: "10px",
              overflow: "hidden",
              background: "#fff",
            }}
          >
            {/* Header */}

            <div
              style={{
                display: "flex",
                padding: "12px",
                background: "#f5f5f5",
                fontWeight: "bold",
                borderBottom: "1px solid #ddd",
              }}
            >
              <div style={{ width: "60px" }}>
                <input
                  type="checkbox"
                  checked={
                    brandCustomers.length > 0 &&
                    selectedRows.length === brandCustomers.length
                  }
                  onChange={(e) => {
                    if (e.target.checked) {
                      const limitedSelection = brandCustomers.slice(
                        0,
                        effectiveLimit
                      );

                      setSelectedRows(limitedSelection);

                      setSelectedOrderIds(
                        limitedSelection.map((item) => item.id)
                      );

                      setSelectedMobileNumbers(
                        limitedSelection.map((item) => item.mobile)
                      );

                      if (
                        brandCustomers.length > effectiveLimit
                      ) {
                        setSelectionError(
                          `You can select maximum ${effectiveLimit} customers`
                        );
                      } else {
                        setSelectionError("");
                      }
                    } else {
                      setSelectedRows([]);
                      setSelectedOrderIds([]);
                      setSelectedMobileNumbers([]);
                      setSelectionError("");
                    }
                  }}
                />
              </div>

              <div style={{ flex: 1 }}>
                Customer Name
              </div>

              <div style={{ flex: 1 }}>
                Mobile
              </div>

            </div>

            {/* Rows */}

            <List
              height={height > 600 ? 400 : 320}
              itemCount={brandCustomers.length}
              itemSize={60}
              width={"100%"}
            >
              {Row}
            </List>
          </div>

          {/* Pagination */}

          <div className="mt-3">
            <Paginator
              first={
                page *
                (brandWhatsappConfig?.whatsappPromoLimit ||
                  10)
              }
              rows={
                brandWhatsappConfig?.whatsappPromoLimit ||
                10
              }
              totalRecords={totalRecords}
              onPageChange={(e) =>
                handlePageChange({
                  page: e.page,
                })
              }
            />
          </div>

          {/* Error */}

          {selectionError && (
            <p
              className="text-lg font-normal text-center mt-2"
              style={{ color: "red" }}
            >
              {selectionError}
            </p>
          )}

          {/* Form */}

          <div className="flex flex-1 mb-3">
            <div className="mx-4 mt-4 flex-1">
              <FloatLabel>
                <Dropdown
                  id="promoTemplate"
                  value={promoTemplate}
                  onChange={(e) =>
                    setPromoTemplate(e.target.value)
                  }
                  options={promoTemplateList}
                  optionLabel="templateName"
                  placeholder="Promo Template"
                  className="w-full border-round-xl text-xl shadow-2"
                />

                <label
                  htmlFor="promoTemplate"
                  className="text-md"
                  style={{ color: "blue" }}
                >
                  Promo Template{" "}
                  <span style={{ color: "red" }}>
                    *
                  </span>
                </label>
              </FloatLabel>

              {promoTemplateError && (
                <p style={{ color: "red" }}>
                  {promoTemplateError}
                </p>
              )}
            </div>

            {/* Calendar */}

            <div className="mx-4 mt-4 flex-1">
              <Calendar
                value={startDate}
                onChange={(e) =>
                  setStartDate(e.value)
                }
                showTime
                hourFormat="12"
                minDate={minimumDate}
                maxDate={maximumDate}
                dateFormat="dd/mm/yy"
                className="w-full"
              />
            </div>
          </div>

          {/* Submit */}

          <div className="flex">
            <Button
              className="mt-1 mb-3 mx-4 border-round-xl w-full"
              onClick={handleSubmit}
              disabled={
                isButtonPressed ||
                selectedOrderIds.length === 0 ||
                selectedOrderIds.length >
                effectiveLimit
              }
            >
              <p className="w-full text-2xl font-semibold flex justify-content-center">
                Submit
              </p>
            </Button>
          </div>
        </>
      )}

      {/* Modals */}

      <SuccessModal
        setModalVisible={setModalVisible}
        modalVisible={modalVisible}
        status={modalStatus}
        text={modalText}
      />

      <AdminMenu
        setVisible={setVisible}
        visible={visible}
      />
    </div>
  );
};

export default PromoTemplateFranchiseCreate;